export default {
    employeeMamagement: 'บริหารจัดการพนักงาน',
    searchBy: 'ค้นหาโดยรหัสพนักงานหรือชื่อ',
    search: 'ค้นหา',
    allStatus: 'สถานะทั้งหมด',
    allEmployment: 'การจ้างงานทั้งหมด',
    name: 'ชื่อ - นามสกุล',
    contact: 'ติดต่อ',
    contactNo: 'เบอร์ติดต่อ',
    group: 'กลุ่ม',
    department: 'แผนก',
    status: 'สถานะ',
    line: 'ไลน์',
    employeeFace: 'รูปพนักงาน',
    action: 'แก้ไข',
    import: 'นำเข้า',
    active: 'ใช้งาน',
    deactive: 'ปิดการใช้งาน',
    createNewEmployee: 'สร้างพนักงานใหม่',
    export: 'ส่งออก',
    deleteEmployee: 'ลบพนักงาน',
    congratulation: 'ยินดีด้วย',
    msgDeleteSuccess: 'พนักงานถูกลบเเล้ว',
    questionDelete: 'คุณเเน่ใจว่าต้องการที่จะลบพนักงาน "$Name" ?',
    allFaceStatus: 'สถานะรูปใบหน้าทั้งหมด',
    validFaceImage: 'มีรูปใบหน้า',
    inValidFaceImage: 'ไม่มีรูปใบหน้า'
}
